// components/Timesheet/EmployeeTimesheets.tsx
import React from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Box,
} from '@mui/material';
import { Check, Close } from '@mui/icons-material';

const EmployeeTimesheets: React.FC = () => {
  // Mock data - replace with actual data from your context/API
  const timesheets = [
    {
      id: '1',
      employeeName: 'John Doe',
      weekStart: '2024-01-01',
      weekEnd: '2024-01-07',
      totalHours: 40,
      status: 'submitted' as const,
    },
    {
      id: '2',
      employeeName: 'Jane Smith',
      weekStart: '2024-01-01',
      weekEnd: '2024-01-07',
      totalHours: 35.5,
      status: 'approved' as const,
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'approved':
        return 'success';
      case 'rejected':
        return 'error';
      case 'submitted':
        return 'warning';
      default:
        return 'default';
    }
  };

  return (
    <div className="p-6">
      <Typography variant="h4" gutterBottom>
        Employee Timesheets
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Employee</TableCell>
              <TableCell>Week</TableCell>
              <TableCell>Total Hours</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {timesheets.map((timesheet) => (
              <TableRow key={timesheet.id}>
                <TableCell>{timesheet.employeeName}</TableCell>
                <TableCell>
                  {timesheet.weekStart} to {timesheet.weekEnd}
                </TableCell>
                <TableCell>{timesheet.totalHours}</TableCell>
                <TableCell>
                  <Chip
                    label={timesheet.status}
                    color={getStatusColor(timesheet.status)}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Box className="space-x-2">
                    <Button
                      variant="outlined"
                      color="success"
                      size="small"
                      startIcon={<Check />}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<Close />}
                    >
                      Reject
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                    >
                      View
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EmployeeTimesheets;